// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"03f7d973","203":"11c5194a","205":"d9156a07"}[chunkId] + ".chunk.css";
};